import R from "ramda";
import {
  BATCH_ASSIGN_CATEGORIES_LOADING,
  BATCH_ASSIGN_CATEGORIES_LOADING_STOP,
  BATCH_EDIT_LOADING,
  BATCH_EDIT_LOADING_STOP,
  DESELECT_DOCUMENTS,
  END_BATCH_CATEGORIES_MODE,
  END_BATCH_EDIT_MODE,
  LOADING_START,
  NEXT_PAGE,
  PREVIOUS_PAGE,
  SELECT_DOCUMENTS,
  SET_PAGINATION_LIMIT,
  SET_DOCUMENTS,
  SET_EDIT_COLUMNS_VISIBILITY,
  SET_TRASH_DOCUMENT_VISIBILITY,
  START_BATCH_EDIT_MODE,
  START_BATCH_CATEGORIES_MODE,
  START_BATCH_DOWNLOAD_MODE,
  START_BATCH_DOWNLOAD_LOADING,
  END_BATCH_DOWNLOAD_MODE,
  TOGGLE_COLUMN,
  SET_CHANGE_DOCUMENT_TYPE_VISIBILITY,
  SET_SHARE_URL_VISIBILITY,
  DOCUMENT_VIEWED,
  START_MERGE_DOCUMENTS_MODE,
  END_MERGE_DOCUMENTS_MODE,
  MERGE_DOCUMENTS_LOADING,
  MERGE_DOCUMENTS_LOADING_STOP,
  SET_TRASH_MULTIPLE_DOCUMENTS_VISIBILITY,
  TRASH_MULTIPLE_DOCUMENTS_LOADING,
  TRASH_MULTIPLE_DOCUMENTS_LOADING_STOP,
  START_HAMBURGER_MODE,
  END_HAMBURGER_MODE,
  START_DOC_VIEWER_HAMBURGER_MODE,
  END_DOC_VIEWER_HAMBURGER_MODE,
  START_DRAGGABILITY,
  END_DRAGGABILITY,
  START_FILTERS_DRAWER_MODE,
  END_FILTERS_DRAWER_MODE,
  RESTORE_DOCUMENTS_LOADING,
  RESTORE_DOCUMENTS_LOADING_STOP,
  DELETE_DOCUMENTS_PERMANENTLY_LOADING,
  DELETE_DOCUMENTS_PERMANENTLY_LOADING_STOP,
  SET_DELETE_PERMANENTLY_VISIBILITY,
  SELECT_MERGE_DOCUMENT,
  DESELECT_MERGE_DOCUMENT,
  SELECT_MERGE_FIELD,
  DESELECT_ALL_DOCUMENTS,
  SET_DOCUMENT_VIEWER_VISIBILITY,
  SELECT_ALL_DOCUMENTS,
  SHARE_URL_GENERATED,
  SET_DOCUMENT_RULES,
  SHOW_GL_CODES_PANEL,
  HIDE_GL_CODES_PANEL,
  DEFAULT_COLUMNS,
  SET_GRID_WIDTH,
  REFRESH_DOCUMENTS,
  SET_REFRESH_INTERVALS,
  CLEAR_REFRESH_INTERVALS,
  START_EXPORT_MODE,
  END_EXPORT_MODE,
  SHIFT_PRESSED,
  SHIFT_RELEASED
} from "actions/documents-actions";
import { SAVE_DOCUMENT, UNFOCUS_DOCUMENT, UPDATE_DOCUMENT_INLINE } from "actions/update-document-actions";
import { UPDATE_CELL, SET_GL_CODE, SPLIT_CATEGORIES } from "actions/exports-actions";
import { BOOTSTRAP_VISIBLE_DOCUMENTS_COLUMNS } from "actions/bootstrap-actions";
import { columnObjects } from "components/grid/column-objects";
import {
  stateForSetDocuments,
  stateForSetPaginationLimit,
  stateForNextPage,
  stateForPreviousPage,
  stateForSelectDocuments,
  stateForDeselectDocuments,
  stateForSelectMergeField,
  stateForSelectMergeDocument,
  updateDocumentState,
  stateForShareUrlGenerated,
  stateForVisibleColumns,
  stateForToggleColumn
} from "reducers/functions/document-functions";

const initialState = {
  columns: columnObjects,
  documents: [],
  filtersCount: 0,
  generatedShareUrl: "",
  glCodes: [],
  gridWidth: 0,
  intervalIds: [],
  isLoading: false,
  isBatchEditMode: false,
  isBatchEditLoading: false,
  isBatchCategoriesMode: false,
  isBatchCategoriesLoading: false,
  isBatchDownloadMode: false,
  isBatchDownloadLoading: false,
  isChangeDocTypeVisible: false,
  isDeletePermanentlyLoading: false,
  isDeletePermanentlyVisible: false,
  isDocumentViewerVisible: true,
  isDocViewerHamburgerMode: false,
  isDraggable: false,
  isEditColumnsVisible: false,
  isExportMode: false,
  isFiltersDrawerMode: false,
  isGLCodesLoading: true,
  isGLCodesVisible: false,
  isHamburgerMode: false,
  isMergeDocumentsLoading: false,
  isMergeDocumentsMode: false,
  isRestoreDocumentsLoading: false,
  isShareUrlVisible: false,
  isShiftPressed: false,
  isTrashMultipleDocumentsLoading: false,
  isTrashMultipleDocumentsVisible: false,
  isTrashDocumentVisible: false,
  mergeDocument: null,
  pagination: {
    pageNumber: 1,
    limit: 20,
    totalCount: 0,
    totalCountFiltered: 0,
    totalSumFiltered: 0
  },
  selectedDocumentIds: [],
  selectedMergeDocumentId: ""
};

export const documentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_START:
      return R.merge(state, { isLoading: true });
    case SET_DOCUMENTS:
      return stateForSetDocuments(state, action);
    case SET_PAGINATION_LIMIT:
      return stateForSetPaginationLimit(state, action.data.update);
    case NEXT_PAGE:
      return stateForNextPage(state);
    case PREVIOUS_PAGE:
      return stateForPreviousPage(state);
    case TOGGLE_COLUMN:
      return stateForToggleColumn(state, action.data.key);
    case SET_EDIT_COLUMNS_VISIBILITY:
      return R.merge(state, { isEditColumnsVisible: action.data.visible });
    case BOOTSTRAP_VISIBLE_DOCUMENTS_COLUMNS:
      return stateForVisibleColumns(state, action.data.columnKeys);
    case SELECT_DOCUMENTS:
      return stateForSelectDocuments(state, action.data.documentIds);
    case DESELECT_DOCUMENTS:
      return stateForDeselectDocuments(state, action.data.documentIds);
    case START_BATCH_EDIT_MODE:
      return R.set(R.lensProp("isBatchEditMode"), true, state);
    case END_BATCH_EDIT_MODE:
      return R.set(R.lensProp("isBatchEditMode"), false, state);
    case BATCH_EDIT_LOADING:
      return R.set(R.lensProp("isBatchEditLoading"), true, state);
    case BATCH_EDIT_LOADING_STOP:
      return R.set(R.lensProp("isBatchEditLoading"), false, state);
    case SAVE_DOCUMENT:
    case UPDATE_DOCUMENT_INLINE:
    case DOCUMENT_VIEWED:
    case SET_GL_CODE:
      return updateDocumentState(state, action);
    case START_BATCH_CATEGORIES_MODE:
      return R.set(R.lensProp("isBatchCategoriesMode"), true, state);
    case END_BATCH_CATEGORIES_MODE:
      return R.set(R.lensProp("isBatchCategoriesMode"), false, state);
    case BATCH_ASSIGN_CATEGORIES_LOADING:
      return R.set(R.lensProp("isBatchCategoriesLoading"), true, state);
    case BATCH_ASSIGN_CATEGORIES_LOADING_STOP:
      return R.set(R.lensProp("isBatchCategoriesLoading"), false, state);
    case START_BATCH_DOWNLOAD_MODE:
      return R.set(R.lensProp("isBatchDownloadMode"), true, state);
    case END_BATCH_DOWNLOAD_MODE:
      return R.merge(state, { isBatchDownloadMode: false, isBatchDownloadLoading: false });
    case START_BATCH_DOWNLOAD_LOADING:
      return R.set(R.lensProp("isBatchDownloadLoading"), true, state);
    case SET_TRASH_DOCUMENT_VISIBILITY:
      return R.merge(state, { isTrashDocumentVisible: action.data.visible });
    case SET_CHANGE_DOCUMENT_TYPE_VISIBILITY:
      return R.merge(state, { isChangeDocTypeVisible: action.data.visible });
    case SET_SHARE_URL_VISIBILITY:
      return R.merge(state, { isShareUrlVisible: action.data.visible, generatedShareUrl: "" });
    case START_MERGE_DOCUMENTS_MODE:
      return R.merge(state, { isMergeDocumentsMode: true, defaultMergeDocument: action.data.mergeDocument });
    case END_MERGE_DOCUMENTS_MODE:
      return R.merge(state, { isMergeDocumentsMode: false, defaultMergeDocument: null });
    case MERGE_DOCUMENTS_LOADING:
      return R.set(R.lensProp("isMergeDocumentsLoading"), true, state);
    case MERGE_DOCUMENTS_LOADING_STOP:
      return R.set(R.lensProp("isMergeDocumentsLoading"), false, state);
    case SET_TRASH_MULTIPLE_DOCUMENTS_VISIBILITY:
      return R.merge(state, { isTrashMultipleDocumentsVisible: action.data.visible });
    case TRASH_MULTIPLE_DOCUMENTS_LOADING:
      return R.merge(state, { isTrashMultipleDocumentsLoading: true });
    case TRASH_MULTIPLE_DOCUMENTS_LOADING_STOP:
      return R.merge(state, { isTrashMultipleDocumentsLoading: false });
    case START_HAMBURGER_MODE:
      return R.merge(state, { isHamburgerMode: true });
    case END_HAMBURGER_MODE:
      return R.merge(state, { isHamburgerMode: false });
    case START_DOC_VIEWER_HAMBURGER_MODE:
      return R.merge(state, { isDocViewerHamburgerMode: true });
    case END_DOC_VIEWER_HAMBURGER_MODE:
      return R.merge(state, { isDocViewerHamburgerMode: false });
    case START_DRAGGABILITY:
      return R.merge(state, { isDraggable: true });
    case END_DRAGGABILITY:
      return R.merge(state, { isDraggable: false, isGLCodesVisible: false });
    case UNFOCUS_DOCUMENT:
      return R.merge(state, { isDraggable: false, isDocViewerHamburgerMode: false });
    case START_FILTERS_DRAWER_MODE:
      return R.merge(state, { isFiltersDrawerMode: true });
    case END_FILTERS_DRAWER_MODE:
      return R.merge(state, { isFiltersDrawerMode: false });
    case RESTORE_DOCUMENTS_LOADING:
      return R.merge(state, { isRestoreDocumentsLoading: true });
    case RESTORE_DOCUMENTS_LOADING_STOP:
      return R.merge(state, { isRestoreDocumentsLoading: false });
    case DELETE_DOCUMENTS_PERMANENTLY_LOADING:
      return R.merge(state, { isDeletePermanentlyLoading: true });
    case DELETE_DOCUMENTS_PERMANENTLY_LOADING_STOP:
      return R.merge(state, { isDeletePermanentlyLoading: false });
    case SET_DELETE_PERMANENTLY_VISIBILITY:
      return R.merge(state, { isDeletePermanentlyVisible: action.data.visible });
    case UPDATE_CELL:
      return updateDocumentState(state, action);
    case SELECT_MERGE_DOCUMENT:
      return stateForSelectMergeDocument(state, action);
    case DESELECT_MERGE_DOCUMENT:
      return R.merge(state, { selectedMergeDocumentId: "" });
    case SELECT_MERGE_FIELD:
      return stateForSelectMergeField(state, action);
    case DESELECT_ALL_DOCUMENTS:
      return R.merge(state, { selectedDocumentIds: [] });
    case SET_DOCUMENT_VIEWER_VISIBILITY:
      return R.merge(state, { isDocumentViewerVisible: action.data.visible });
    case SELECT_ALL_DOCUMENTS:
      return R.merge(state, { selectedDocumentIds: action.data.documentIds, documents: action.data.documents });
    case SHARE_URL_GENERATED:
      return stateForShareUrlGenerated(state, action.data.shareUrl);
    case SET_DOCUMENT_RULES:
      return R.merge(state, { documents: action.data.newDocuments, isGLCodesLoading: false });
    case SHOW_GL_CODES_PANEL:
      return R.merge(state, { isGLCodesVisible: true });
    case HIDE_GL_CODES_PANEL:
      return R.merge(state, { isGLCodesVisible: false });
    case SPLIT_CATEGORIES:
      return R.merge(state, { glCodes: action.data.strippedGlCodes });
    case DEFAULT_COLUMNS:
      return R.merge(state, { columns: columnObjects });
    case SET_GRID_WIDTH:
      return R.merge(state, { gridWidth: action.data.width });
    case REFRESH_DOCUMENTS:
      return R.merge(state, { documents: action.data.documents });
    case SET_REFRESH_INTERVALS:
      return R.merge(state, { intervalIds: action.data.intervalIds });
    case CLEAR_REFRESH_INTERVALS:
      return R.merge(state, { intervalIds: [] });
    case START_EXPORT_MODE:
      return R.merge(state, { isExportMode: true });
    case END_EXPORT_MODE:
      return R.merge(state, { isExportMode: false });
    case SHIFT_PRESSED:
      return R.merge(state, { isShiftPressed: true });
    case SHIFT_RELEASED:
      return R.merge(state, { isShiftPressed: false });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/js/reducers/documents-reducer.js